import { gql } from '@apollo/client'

const massiveLoadTemplateMutation = gql`
mutation ExecuteMassiveLoadTemplateMutation(
    $model:String!,
    $context:String,
) {
    executeMassiveLoadTemplate (
        model:$model,
        context:$context,
    )
    {
        massiveLoadTemplate{
            id
            user {
                id
                firstName
                lastName
            }
            createdAt
            state
            message
            modelName
        }
    }
}
`

export default massiveLoadTemplateMutation;